import classNames from 'classnames'
import styles from './_popover.module.scss'

const Popover: React.FC<{
  children: React.ReactNode
  style?: string
}> = ({ children, style }) => {
  return (
    <div className={classNames(styles.popover, style)}>
      <div className={styles.arrow} />
      {children}
    </div>
  )
}

export default Popover
